import ColorDialog from './ColorDialog';

export default ColorDialog;
